import React, { useState } from "react";
import moment from 'moment-jalaali'
import { Form } from 'antd';
// import DatePicker from 'react-datepicker2'
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";


export default function TicketsFilter({ type }) {
    const { business } = usePersistedStore();
    const general = useGeneralStore();
    const [fromDate, setFromDate] = useState(null);
        const [toDate, setToDate] = useState(null);
    const loading = general.tickets.loading;
    const Token = business.currentBusiness.token

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {

        if (type === "contact") {
            general.getTickets({
                id: 2,
                isTicket: false,
                fromDate: convertToMoment(fromDate),
                toDate: convertToMoment(toDate),
            }, Token);

        } else {
            general.getTickets({
                id: 2,
                isTicket: true,
                fromDate: convertToMoment(fromDate),
                toDate: convertToMoment(toDate),
            }, Token);
        }
    }

    return (
        <div>
            <Form
                layout="inline" onFinish={onFinish}
                initialValues={{
                    fromDate: moment(),
                    toDate: moment()
                }}
            >
                <Form.Item
                    name='fromDate'
                    label='از تاریخ'>
                    <DatePicker
                        value={fromDate}
                        onChange={setFromDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <Form.Item
                    name='toDate'
                    label='تا تاریخ'>
                    <DatePicker
                        value={toDate}
                        onChange={setToDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <Form.Item label=" " colon={false}>
                    <button
                        disabled={loading} type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit">
                        جستجو&nbsp;&nbsp;&nbsp; <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                    </button>
                </Form.Item>
            </Form>
        </div>
    )
}